import GenerateChart from './GenerateChart';

export default {
  extends: GenerateChart,
  props: {
    chartId: {
      default: 'horizontalbar-chart',
      type: String,
    },
    chartType: {
      type: String,
      default: 'horizontalBar',
    },
    datasets: {
      type: Array,
      default: [],
    },
    labels: {
      type: Array,
      default: [],
    },
    options: {
      type: Object,
      default: { responsive: true, maintainAspectRatio: false },
    },
  },
  mounted() {
    this.renderChart(
      {
        labels: this.labels,
        datasets: this.datasets,
      },
      this.options
    );
  },
};
